import { render, staticRenderFns } from "./DetailInventory.vue?vue&type=template&id=6ba1dbc7&"
import script from "./DetailInventory.vue?vue&type=script&lang=js&"
export * from "./DetailInventory.vue?vue&type=script&lang=js&"
import style0 from "./DetailInventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports